function normalizeLookup(value) {
  return String(value || "")
    .trim()
    .toLowerCase();
}

export function resolveCandidateCategoryKey(candidate, categories = [], preferredKey = "") {
  if (preferredKey && categories.some((category) => category.key === preferredKey)) {
    return preferredKey;
  }
  if (
    candidate?.suggestedCategoryKey &&
    categories.some((category) => category.key === candidate.suggestedCategoryKey)
  ) {
    return candidate.suggestedCategoryKey;
  }

  const raw =
    candidate?.rawCategory ||
    candidate?.normalizationData?.fields?.category?.raw ||
    candidate?.rawPayload?.mapped?.category ||
    null;
  if (!raw) return "";

  const normalized = normalizeLookup(raw);
  const exact = categories.find((category) => normalizeLookup(category.key) === normalized);
  if (exact) return exact.key;

  const byName = categories.find((category) => {
    const names = [category.name, category.nameEs, category.nameEn].filter(Boolean).map(normalizeLookup);
    return names.includes(normalized);
  });
  return byName?.key || "";
}

export function resolveCandidateMunicipalityId(candidate, municipalities = [], preferredId = "") {
  if (preferredId && municipalities.some((municipality) => municipality.id === preferredId)) {
    return preferredId;
  }
  if (
    candidate?.suggestedMunicipalityId &&
    municipalities.some((municipality) => municipality.id === candidate.suggestedMunicipalityId)
  ) {
    return candidate.suggestedMunicipalityId;
  }

  const raw = candidate?.rawMunicipality || candidate?.normalizationData?.fields?.municipality?.raw || null;
  if (!raw) return "";

  const normalized = normalizeLookup(raw);
  const match = municipalities.find((municipality) => {
    const names = [municipality.name, municipality.key].filter(Boolean).map(normalizeLookup);
    return names.includes(normalized);
  });
  return match?.id || "";
}

export function evaluateCandidateAcceptReadiness({
  candidate,
  categoryKey,
  municipalityId,
  categories = [],
}) {
  const displayName = candidate?.rawName || candidate?.normalizedName || "";
  const categoryValid = Boolean(categoryKey && categories.some((category) => category.key === categoryKey));
  const municipalityValid = Boolean(municipalityId);

  const categoryField = candidate?.normalizationData?.fields?.category;
  const municipalityField = candidate?.normalizationData?.fields?.municipality;

  const blockers = [];
  if (!displayName.trim()) blockers.push("displayName");
  if (!categoryValid) blockers.push("primaryCategory");

  const advisories = [];
  if (!municipalityId) advisories.push("municipality");
  if (categoryField?.status === "unmatched" || categoryField?.requiresReview) {
    advisories.push("categoryReview");
  }
  if (municipalityField?.status === "unmatched" || municipalityField?.requiresReview) {
    advisories.push("municipalityReview");
  }
  if (candidate?.status === "possible_duplicate") advisories.push("duplicateReview");

  return {
    canAccept: blockers.length === 0,
    blockers,
    advisories,
    categoryNeedsReview: categoryField?.status !== "matched" || !categoryValid,
    municipalityNeedsReview: municipalityField?.status !== "matched" || !municipalityId,
    hasMunicipality: Boolean(municipalityId),
    municipalityValid,
  };
}
